export default __webpack_public_path__ + "static/media/Fooddudes1.c4464c4d.svg";